<select [attr.aria-label]="'select state'" (ngModelChange)="writeValue($event);" [ngModel]="value"
        [tabindex]="tabindex" class="form-control"
        [disabled]="readonly"
        title="{{placeholder}}">

    <option [ngValue]="null">-- Select --</option>

    <optgroup *ngFor="let country of countries" label="{{country.country}}">
        <option *ngFor="let region of country.regions" [attr.aria-label]="region.region" [ngValue]="region" [selected]="region === value">
            {{region.region}}
        </option>
    </optgroup>
</select>
